/**
 * The server's clock. Branch PCs may have a wrong clock, so every business
 * date ("today", the default report period) follows the API's time. Each
 * successful API response carries `timestamp` in its envelope; the offset to
 * this PC's clock is remembered and applied by `serverNow()`.
 */
let offsetMs = 0;

/** Records the server time from a response envelope's ISO `timestamp`. */
export function syncServerClock(timestamp: unknown, received: number = Date.now()): void {
  if (typeof timestamp !== 'string') return;
  const server = Date.parse(timestamp);
  if (Number.isNaN(server)) return;
  offsetMs = server - received;
}

/** The current instant according to the server (the PC clock until first sync). */
export function serverNow(): Date {
  return new Date(Date.now() + offsetMs);
}

/** Test helper. */
export function resetServerClock(): void {
  offsetMs = 0;
}
